import GraphicStandForms from './forms';
import GraphicStandFields from './fields';
import GraphicStandFilters from './filters';
import GraphicStandHelpers from './helpers';
import { useGraphicStandMutation } from './hooks';
import { GRAPHIC_STAND_STATUS } from './graphic-stand-const';

import './graphic-stand.scss';


const GraphicStand = {
    Forms: GraphicStandForms,
    Fields: GraphicStandFields,
    Filters: GraphicStandFilters,
    Helpers: GraphicStandHelpers,
    Hooks: useGraphicStandMutation,
    Const: {
        status: GRAPHIC_STAND_STATUS,
        basePath: '/stands'
    }
};

export default GraphicStand;